<template>
    <Header></Header>
    <div class="container _intro sub_page">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01 _xsmall spin3"><img src="img/b_icon_03.png" /></i>
                <i class="deco_02 _small blink_zoom1"><img src="img/b_icon_01.png" /></i>
                <i class="deco_03 _xsmall spin_blink2"><img src="img/b_icon_03.png" /></i>
                <i class="deco_04 _small blink_blink3"><img src="img/b_icon_01.png" /></i>
                <i class="deco_character"><img src="img/intro_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>소개</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']">
                        <a href="javascript:void(0)">반성매매 시민참여 플랫폼</a>
                    </li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">다시함께상담센터</a></li>
                    <li @click="changeTab(3)" :class="[state.tab === 3 ? 'active' : '']"><a href="javascript:void(0)">자주 묻는 질문</a></li>
                </ul>
            </div>
        </section>
        <section class="sub_page_con wrap_1120">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>
                <!--
                 <span class="icon_wrap"><img src="img/part_icon.png" alt="소개" /></span>
                <a href="">소개</a> 
                -->
                <span class="icon_wrap"><img src="img/part_icon.png" alt="자주묻는 질문(FAQ)" /></span>
                <router-link :to="{ path: '/intro', query: { type: 3 } }">자주묻는 질문(FAQ)</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="서울시 인터넷시민감시단 참여 신청은 어디서 하나요?" /></span>
                <a class="faq_title">{{ state.data.title }}</a>
            </div>
            <div class="sub_page_con_view con_view">
                <div class="tit_wrap flex_wrap">
                    <span class="con_tit">{{ state.data.title }}</span>
                </div>
                <div class="content_wrap">
                    <div class="content" v-html="CommonUtils.decodeContent(state.data.content)"></div>

                    <div class="file_list_wrap _column" v-if="state.data.fileList != null && state.data.fileList.length > 0">
                        <div v-for="item in state.data.fileList" :key="item.fileIdx">
                            <button type="button" @click="downloadFile(item.file, item.fileImgRealName)">
                                <span class="file_name">{{ item.fileImgRealName }}</span>
                                <img src="img/download.png" alt="" />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="btn_wrap _default right_btn _board_type" v-if="state.hasAuth">
                    <button class="common_btn _gray" type="button" @click="confirmRemove">삭제</button>
                    <button class="common_btn" type="button" @click="router.push({ name: 'FaqModify', params: { id: state.idx } })">수정</button>
                    <button class="common_btn" type="button" @click="router.push('/intro?type=3')">목록</button>
                </div>
            </div>
            <div class="list_wrap">
                <router-link v-if="state.data.next" :to="{ name: 'FaqView', params: { id: state.data.next.idx } }" class="next_list">
                    <span>다음글</span>
                    <div class="list_tit elips_1">
                        {{ state.data.next.title }}
                    </div>
                    <div class="list_date" v-if="!state.isMobile">{{ CommonUtils.dateFormat(new Date(state.data.next.createDate), ".", true) }}</div>
                    <div class="list_date" v-else>{{ CommonUtils.dateFormatForMobile(new Date(state.data.next.createDate), ".", true) }}</div>
                </router-link>

                <router-link v-if="state.data.prev" :to="{ name: 'FaqView', params: { id: state.data.prev.idx } }" class="prev_list">
                    <span>이전글</span>
                    <div class="list_tit elips_1">
                        {{ state.data.prev.title }}
                    </div>
                    <div class="list_date" v-if="!state.isMobile">{{ CommonUtils.dateFormat(new Date(state.data.prev.createDate), ".", true) }}</div>
                    <div class="list_date" v-else>{{ CommonUtils.dateFormatForMobile(new Date(state.data.prev.createDate), ".", true) }}</div>
                </router-link>
            </div>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <Footer></Footer>
</template>
<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        PageBtn,
        useRoute,
        Header,
        Footer,
        ModalDefault,
        onBeforeMount,
        userStore,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, PageBtn, ModalDefault },
        setup() {
            const route = useRoute();
            const user = userStore();
            const global = globalStore();
            const state = reactive({
                tab: 3 as number,
                idx: 0 as number,

                data: {} as types.ResFaqVOForApi,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                hasAuth: false as boolean,

                subMenuOpen: false as boolean,
                subMenuName: "자주 묻는 질문" as string,

                isMobile: false,
            });

            onBeforeMount(() => {
                if (user.isLogin() && user.userInfo.gubun === 1) state.hasAuth = true;
            });

            onMounted(() => {
                const idx = Number(route.params.id);

                if (idx && typeof idx === "number" && !isNaN(idx)) {
                    state.idx = idx;
                    getDetail();
                } else {
                    router.back();
                }

                state.isMobile = window.innerWidth < 768;
            });

            watch(
                () => route.params.id,
                () => {
                    const idx = Number(route.params.id);
                    state.idx = idx;
                    getDetail();
                },
            );

            const getDetail = async () => {
                const res = await apiService.faq.detail(state.idx);

                if (res.returnCode === 0) {
                    state.data = res.data;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const changeTab = (tab: number) => {
                global.setIntroTab(tab);
                router.push("/intro");
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "반성매매 시민참여 플랫폼";
                        break;
                    case 2:
                        state.subMenuName = "다시함께상담센터";
                        break;
                    case 3:
                        state.subMenuName = "자주 묻는 질문";
                        break;
                }
            };
            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };
            const closeModal = () => {
                state.isShowModal = false;
                if (state.modalTab === 8) router.back();
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    removeData();
                } else if (param.action === "callback") {
                    state.isShowModal = false;
                    router.replace({ path: "/login", query: { redirect: "/faqView/" + state.idx } });
                } else if (param.action === "back") {
                    state.isShowModal = false;
                    router.replace("/intro?type=3");
                }
            };

            const removeData = async () => {
                const res = await apiService.faq.remove(state.idx);

                if (res.returnCode === 0) {
                    state.modalTab = 8;
                    state.isShowModal = true;
                    state.modalTitle = "안내";
                    state.modalContent = getMessageByCode(res.returnCode);
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirmRemove = () => {
                if (user.isLogin()) {
                    state.modalTab = 5;
                    state.modalTitle = "안내";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                }
            };

            return { state, router, CommonUtils, downloadFile, changeTab, subMenuTab, closeModal, callBackModal, confirmRemove };
        },
    };
</script>
<style scoped>
    .faq_title {
        color: #6d6d6d;
        font-size: 14px;
        font-weight: 500;
    }

    .list_wrap a[class*="_list"]:nth-child(2) {
        border-top: 1px solid #c4c4c4;
    }

    .list_wrap a[class*="_list"] {
        display: flex;
        gap: 10px;
        padding: 10px 0;
        position: relative;
        cursor: pointer;
    }

    .list_wrap a[class*="_list"]:hover {
        background-color: #fafafa;
    }

    .list_wrap a[class*="_list"] span {
        background-color: #fff9e9;
        padding: 3px 10px;
        color: #ff8935;
        font-weight: 500;
        font-size: 14px;
    }
</style>
